export default __webpack_public_path__ + "static/media/B664.782dabf4.webp";